var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabelOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "currentColor",
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.885 4.141c.535 0 1.014.253 1.302.643l3.163 4.272c.2.268.2.62 0 .888l-3.164 4.272c-.287.39-.766.643-1.301.643l-8.788-.008c-.823 0-1.507-.599-1.589-1.367l-.008-.156V5.672c0-.842.719-1.523 1.597-1.524l8.788-.007Zm-9.26 9.187c0 .169.162.398.472.398l8.788.007a.49.49 0 0 0 .396-.185l.002-.002L15.279 9.5l-2.996-4.046-.002-.003a.491.491 0 0 0-.396-.185l-8.788.007c-.31 0-.472.23-.472.399v7.656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelOutline);
export default __webpack_public_path__ + "static/media/label_outline.177e289785fa72fa9bfb5ae4cab92e7b.svg";
export { ForwardRef as ReactComponent };